import { TranslateService } from '@ngx-translate/core';
import { ApiSelectorService } from 'src/app/core/services/api-selector/api-selector.service';
import { Injectable } from '@angular/core';
import { HttpParams, HttpHeaders, HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { HttpError } from 'src/app/models/http-error.model';
import { config } from '../../config'
import { UtilsService } from '../utils/utils.service';
import { AlertController, Platform } from '@ionic/angular';
import { map, catchError } from 'rxjs/operators';
import { Response } from 'src/app/models/response.model';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class HttpHelpersService {

  private static token = null;
  private url: string;

  constructor(private utils: UtilsService,
    private alertController: AlertController,
    private http: HttpClient,
    private platform: Platform,
    private apiSelectorService: ApiSelectorService,
    private translate: TranslateService
  ) {
    this.url = this.getUrl();
  }

  getUrl() {
    return `${this.apiSelectorService.SERVER_CONFIG}/${environment.SERVER_CONFIG.accesoUrl}`;
  }

  getBaseUrlCCloud() {
    return `${this.apiSelectorService.SERVER_CONFIG}`;
  }

  setParams(paramsObject) {
    let httpParams = new HttpParams();
    for (const key in paramsObject) {
      httpParams = httpParams.append(key, paramsObject[key]);
    }
    return { params: httpParams };
  }

  errorHandler(operation) {
    return (error: any): Observable<HttpError> => {
      if (error.status === 401 && !error.url.includes('login') && !error.url.includes('logout')) {
        const fd = new FormData();
        if (this.platform.is('android') || this.platform.is('ios')) {
          this.utils.getFromStorage('user').then(({ uuid }) => {
            fd.append('uuid', uuid);
            this.logOutGeneral(fd);
          })
        } else
          this.logOutGeneral(fd);
      }

      let errorMsg = error && error.error && error.error.message ? error.error.message : '';
      let errorToReturn: HttpError = {
        operation: errorMsg || `${this.translate.instant('http-helpers.Error al')} ${operation}`,
        error,
      };
      return of(errorToReturn);
    };
  }


  logOutGeneral(fd) {
    this.utils.removeFromStorage('savedCredentialsForFingerprint');

    this.logout(fd)
      .subscribe(async () => {
        await this.utils.logOutHelper();
        setTimeout(() => {
          this.alertController.getTop().then((isAlertPresented) => {
            if (!isAlertPresented) {
              this.alertController.create({
                header: this.translate.instant('http-helpers.Usuario no autenticado'),
                message: this.translate.instant('http-helpers.Debe iniciar sesión nuevamente'),
                backdropDismiss: false,
                buttons: [
                  this.translate.instant('http-helpers.Aceptar')
                ]
              }).then(alert => {
                alert.present();
              });
            }
          });
        }, 1500);
      });
  }


  setHeader(accessToken) {
    this.utils.saveInStorage('token', accessToken);
    HttpHelpersService.token = accessToken;
  }

  getHeader() {
    if (!this.platform.is('android') || !this.platform.is('ios'))
      HttpHelpersService.token = HttpHelpersService.token || localStorage.getItem('token');
    return {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${HttpHelpersService.token}`,
        'accept-language': this.translate.currentLang
      })
    }
  }

  logout(uuid?): Observable<any> {
    const httpOptions = {
      ...this.getHeader()
    }

    return this.http.post<Response>(`${this.url}/auth/logout`, uuid, httpOptions).pipe(map(({ data }) => {
      return data
    }), catchError(this.errorHandler(this.translate.instant('http-helpers.cerrar sesión'))));
  }
}
